import { Box, Grid, Text } from '@domain-group/suit-theme'

const InvalidPricesListItemHeader = () => (
  <Grid
    // @ts-expect-error TS2322
    gridTemplateColumns="28px minmax(80px,5fr) minmax(80px,1fr) minmax(80px,1fr) minmax(18px,32px) minmax(18px,32px)"
    alignItems="center"
    fontSize="xsmall"
  >
    <Box /> {/* Gap */}

    <Text color="faintGrey">Item</Text>

    <Text color="faintGrey" textAlign="right">Old Price</Text>

    <Text color="faintGrey" textAlign="right">New Price</Text>

    <Box /> {/* Gap */}

    <Box /> {/* Gap */}
  </Grid>
)

export default InvalidPricesListItemHeader
